import { Injectable, inject } from '@angular/core';
import {
  ProjectPermitTaskServiceCreateResponse,
  ProjectPermitTaskServiceCreateResponseSchema,
  ProjectPermitTaskServiceGetResponseSchema,
  ProjectPermitTaskServiceListRequest,
  ProjectPermitTaskServiceUpdateRequest,
  ProjectPermitTaskServiceUpdateResponseSchema,
} from '@vmspdb/definitions';
import { ConnectProjectPermitTask } from '@vmspdb/ui/connect';
import { ApiPaginated } from '@vmspdb/ui/domain';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRepositoryService } from './api-repository.service';
import { reencode } from './reencode';

@Injectable({
  providedIn: 'root',
})
export class PermitTaskRepositoryService implements ApiRepositoryService<
  ProjectPermitTaskServiceUpdateRequest,
  ProjectPermitTaskServiceUpdateRequest,
  ProjectPermitTaskServiceListRequest,
  ProjectPermitTaskServiceCreateResponse
> {
  private api = inject(ConnectProjectPermitTask);

  create(): Observable<ProjectPermitTaskServiceCreateResponse> {
    throw new Error('unimplemented intentionally');
  }

  delete(): Observable<void> {
    throw new Error('unimplemented intentionally');
  }

  fetch(uuid: string): Observable<ProjectPermitTaskServiceCreateResponse> {
    return this.api
      .get({ uuid })
      .pipe(
        map((res) =>
          reencode(
            ProjectPermitTaskServiceGetResponseSchema,
            ProjectPermitTaskServiceCreateResponseSchema,
            res,
          ),
        ),
      );
  }

  list(
    request: ProjectPermitTaskServiceListRequest,
  ): Observable<ApiPaginated<ProjectPermitTaskServiceCreateResponse>> {
    return this.api.list(request);
  }

  update(
    data: ProjectPermitTaskServiceUpdateRequest,
  ): Observable<ProjectPermitTaskServiceCreateResponse> {
    return this.api
      .update(data)
      .pipe(
        map((res) =>
          reencode(
            ProjectPermitTaskServiceUpdateResponseSchema,
            ProjectPermitTaskServiceCreateResponseSchema,
            res,
          ),
        ),
      );
  }
}
